import createMockSource from 'utils/createMockSource';

export const maintenancePageMocks = createMockSource('maintenancePage', {
    groundedDrones: 2
});
